// client/src/components/agendamentos/BloqueioListItem.js
// client/src/components/agendamentos/BloqueioListItem.js
import React from 'react';
import { Lock, User, Box, MapPin } from 'lucide-react';
import { useAuth } from '../../context/auth/AuthProvider';

const BloqueioListItem = ({ bloqueio, onClick }) => {
    const { hasPermission } = useAuth();

    const formatTime = (dateString) => {
        if (!dateString) return '';
        try {
            return new Date(dateString).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        } catch (e) {
            return 'Inválido';
        }
    }

    const horario = bloqueio.diaInteiro 
        ? 'Dia Inteiro' 
        : `${formatTime(bloqueio.dataInicio)} - ${formatTime(bloqueio.dataFim)}`;
        
    const canInteract = hasPermission && (hasPermission('bloqueios:edit') || hasPermission('bloqueios:delete'));

    const entidadeBloqueada = bloqueio.entidadeAgendavel;
    const nomeEntidade = entidadeBloqueada?.name || 'Entidade não informada';
    const tipoEntidade = bloqueio.tipoEntidade;
    const nomeEndereco = bloqueio.unidade?.nome;

    return (
        <li 
            className={`agenda-list-item is-bloqueio ${canInteract ? 'is-interactive' : ''}`} 
            onClick={canInteract ? onClick : undefined}
            title={canInteract ? 'Clique para ver detalhes' : ''}
        >
            <div className="item-time">
                {horario}
            </div>
            
            <div className="item-details">
                <h4 className="item-title">
                    <Lock size={14} className="icon" />
                    {bloqueio.motivo}
                </h4>

                <p className="item-subtext">
                    {tipoEntidade === 'User' ? <User size={14} className="icon"/> : <Box size={14} className="icon"/>}
                    {nomeEntidade}
                </p>

                {nomeEndereco && (
                    <p className="item-subtext text-gray-500">
                        <MapPin size={14} className="icon" />
                        {nomeEndereco}
                    </p>
                )}
            </div>

            <div className="item-meta">
                {/* Espaço reservado para futuras informações ou ações */}
            </div>
        </li>
    );
};

export default BloqueioListItem;